/**
 * Utility class that exposes RegexMatchers for different patterns used by the default formatter.
 */
class DefaultFormatterMatchers {
    constructor() {
        this.nullConditionPattern = DefaultFormatterMatchers.createRegexPattern(DefaultFormatterMatchers.NullConditionRegex, "i");
        this.conditionPattern = DefaultFormatterMatchers.createRegexPattern(DefaultFormatterMatchers.ConditionRegex, "i");
        this.arithmeticPattern = DefaultFormatterMatchers.createRegexPattern(DefaultFormatterMatchers.ArithmeticRegex, "i");
        this.colorPattern = DefaultFormatterMatchers.createRegexPattern(DefaultFormatterMatchers.ColorRegex, "i");
        this.customColorPattern = DefaultFormatterMatchers.createRegexPattern(DefaultFormatterMatchers.CustomColorRegex, "i");
        this.customBgColorPattern = DefaultFormatterMatchers.createRegexPattern(DefaultFormatterMatchers.CustomBackgroundColorRegex, "i");
        this.anyCustomColorPattern = DefaultFormatterMatchers.createRegexPattern(DefaultFormatterMatchers.AnyCustomColorRegex, "i");
        this.excelFormatSuffixPattern = DefaultFormatterMatchers.createRegexPattern(DefaultFormatterMatchers.ExcelFormatSuffixRegex);
    }
    static createRegexPattern(pattern, flags) {
        return flags ? new RegExp(pattern.source, flags) : pattern;
    }
    getNullConditionMatcher() {
        return this.nullConditionPattern;
    }
    getConditionMatcher() {
        return this.conditionPattern;
    }
    getArithmeticMatcher() {
        return new RegExp(this.arithmeticPattern, "g");
    }
    getColorMatcher() {
        return this.colorPattern;
    }
    getCustomColorMatcher() {
        return this.customColorPattern;
    }
    getCustomBgColorMatcher() {
        return this.customBgColorPattern;
    }
    getAnyCustomColorMatcher() {
        return this.anyCustomColorPattern;
    }
    getExcelFormatSuffixMatcher() {
        return this.excelFormatSuffixPattern;
    }
    static group(match, group) {
        if (match && group >= 0 && group < match.length) {
            const value = match[group];
            if (value === undefined) {
                return { value, startIndex: -1, endIndex: -1 };
            }
            const startIndex = match.index + match[0].indexOf(value);
            const endIndex = startIndex + value.length;
            return { value, startIndex, endIndex };
        }
        throw new Error(`Group ${group} not found in the regex match.`);
    }
}
DefaultFormatterMatchers.NullConditionRegex = /\[=null\]/i;
DefaultFormatterMatchers.ConditionRegex = /\[(>=|<=|[=><])(-?[0-9.]+|null)\]/i;
DefaultFormatterMatchers.ArithmeticRegex = /\{\{\{([0-9]*(?:\.[0-9]*)?)\|([0-9]*)(\.)?\|(.*?)\}\}\}/;
DefaultFormatterMatchers.ColorRegex = /\[(black|blue|cyan|green|magenta|red|white|yellow|none)\]/i;
DefaultFormatterMatchers.CustomColorRegex = /\[color=#*([A-F0-9]+)\]/i;
DefaultFormatterMatchers.CustomBackgroundColorRegex = /\[backgroundColor=#*([A-F0-9]+)\]/i;
DefaultFormatterMatchers.AnyCustomColorRegex = /(\[(?:backgroundColor|color)=#*[A-Fa-f0-9]+\])+/;
DefaultFormatterMatchers.ExcelFormatSuffixRegex = /\[excel\]([\s\S])*$/i;
export { DefaultFormatterMatchers };
//# sourceMappingURL=regex.js.map